import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Terms of Service"
        description="PathProxy terms and conditions. Read our service agreement covering acceptable use, payments, refunds, data collection, and account policies."
        path="/terms"
      />
      <Navbar />

      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-subtitle">Last updated: January 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. Services</h2>
            <p>
              pathproxy provides proxy services that route internet traffic through multiple IP addresses.
              Our services include Rotating Residential Basic and Rotating Residential Premium proxies.
              By using our services, you agree to these terms and conditions.
            </p>

            <h2>2. IP Address Disclaimer</h2>
            <p>
              pathproxy does not directly control the end IP addresses used in our services.
              Our rotating residential proxies are sourced from ethically obtained residential connections.
              We cannot guarantee specific IP addresses or their availability at any given time.
            </p>

            <h2>3. Acceptable Use Policy</h2>
            <p>You agree NOT to use our services for:</p>
            <ul>
              <li>Any illegal activities or actions that violate applicable laws</li>
              <li>Infringing on intellectual property rights of others</li>
              <li>Distributing malware, viruses, or malicious code</li>
              <li>Sending spam or unsolicited communications</li>
              <li>Attempting to gain unauthorized access to systems</li>
              <li>Activities that could damage or disrupt our services</li>
              <li>Fraud, identity theft, or financial crimes</li>
            </ul>
            <p>
              Violation of this policy may result in immediate termination of your account without refund.
            </p>

            <h2>4. Data Collection</h2>
            <p>
              We collect minimal data necessary to provide our services:
            </p>
            <ul>
              <li>Email addresses and usernames for account management</li>
              <li>Traffic usage data for billing purposes</li>
              <li>Performance metrics (retained for a maximum of 6 hours)</li>
            </ul>
            <p>
              We do not log your browsing activity or the content of your traffic.
              See our Privacy Policy for more details.
            </p>

            <h2>5. Payment Processing</h2>
            <p>
              Payments are processed through secure third-party payment processors.
              We accept cryptocurrency payments (Bitcoin, Ethereum) for enhanced privacy.
              We do not store your payment card details on our servers.
            </p>

            <h2>6. Confidentiality</h2>
            <p>
              Any non-public business information shared between parties shall be treated as confidential.
              This includes API credentials, account details, and any proprietary information.
            </p>

            <h2>7. Service Availability</h2>
            <p>
              We strive to maintain 99.9% uptime for all our services. If our services experience
              downtime exceeding 30 continuous minutes, you may be eligible for service credit
              or replacement. Contact our support team with details of the outage.
            </p>

            <h2>8. Purchases and Refunds</h2>
            <p>
              All purchases are subject to our Refund Policy. Please review our refund terms
              before making a purchase. We offer refunds within 24 hours of purchase under
              certain conditions as outlined in our Refund Policy.
            </p>

            <h2>9. Limitation of Liability</h2>
            <p>
              pathproxy shall not be liable for any indirect, incidental, special, consequential,
              or punitive damages resulting from your use of our services. Our total liability
              shall not exceed the amount you paid for the services in the 12 months preceding the claim.
            </p>

            <h2>10. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless pathproxy, its officers, directors, employees,
              and agents from any claims, damages, or expenses arising from your use of our services
              or violation of these terms.
            </p>

            <h2>11. Account Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account at any time for violation
              of these terms. You may also terminate your account at any time by contacting support.
              Upon termination, your access to services will cease immediately.
            </p>

            <h2>12. Law Enforcement</h2>
            <p>
              We cooperate with law enforcement agencies when required by law. Due to our proxy
              architecture and minimal logging policy, we may not be able to identify specific
              users by IP address.
            </p>

            <h2>13. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be posted on
              this page with an updated revision date. Continued use of our services after changes
              constitutes acceptance of the new terms.
            </p>

            <h2>14. Contact Information</h2>
            <p>
              For questions about these Terms & Conditions, please contact us through:
            </p>
            <ul>
              <li>Our Discord server</li>
              <li>Telegram support</li>
              <li>Support ticket system in your dashboard</li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
